import Bugsnag from '@bugsnag/js';
import React from 'react';

import { notifyReactError } from 'bugsnag/utils';
import { DefaultError } from 'error/components/DefaultError';

interface IBugsnagProvider {
  children: any;
}

interface IBugsnagProviderState {
  hasError: boolean;
}

export default class BugsnagProvider extends React.Component<
  IBugsnagProvider,
  IBugsnagProviderState
> {
  constructor(props: IBugsnagProvider) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    // log the error to an error reporting service

    // Indicate that an error was handled by this boundary
    Bugsnag.leaveBreadcrumb('BugsnagProviderErrorBoundary', {
      name: error?.name,
      message: error?.message,
      fallback: 'DefaultError',
    });

    // Generate formatted Bugsnag report
    notifyReactError(error, errorInfo);
  }

  render() {
    const { hasError } = this.state;
    const { children } = this.props;

    if (hasError) {
      // render any custom fallback UI
      return <DefaultError />;
    }

    return children;
  }
}
